module Types

type Todo = {
    id: int
    mutable title: string
    mutable completed: bool
}


// WEBPACK FOOTER //
// src/vue-todomvc/Types.fs